import { ICategory } from '@Encore-FastStartup-Phase-Out/encore-shared';

import { endpoints } from '../constants/endpoints';

import { BaseApi } from './index';

export class CategoryApi extends BaseApi<any> {
  constructor() {
    super(endpoints.category.base);
  }

  async getCategories(): Promise<ICategory[]> {
    // @ts-ignore
    return this.fetch(endpoints.category.base, {});
  }
}
